module.exports = __webpack_public_path__ + "static/media/upload-file-icon.0aa9bac5.svg";